import LeftNav1 from "../components/LeftNav1";
import NetworkModal from "../components/NetworkModal";

const Network = () => {
  return (
    <div className="h-screen overflow-hidden">
      <div className="flex p-1 mx-auto overflow-hidden justify-center w-[1300px] h-[620px] text-center text-xs text-darkslategray font-open-sans">
        <div className="bg-gray-200 mr-1">
          <LeftNav1 />
        </div>
        <div className="w-[1073px] bg-white mr-5 bg-tl-screen bg-center bg-cover h-[605px]">
          <div className="flex justify-end max-w-full h-full bg-gray backdrop-brightness-20">
            <img className="relative top-[13px] left-[127px] w-[105px] h-[13px]"
              alt=""
              src="/icon-networing.png"
            />
            <NetworkModal />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Network;
